import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { directMailAPI } from "api/Interactions/DirectMailAPI";

interface AddDirectMailPopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newDirectMail: any) => void;
}

const AddDirectMailPopup: React.FC<AddDirectMailPopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Direct Mail"
      createFunction={directMailAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Title", required: true },
        { name: "description", label: "Description" },
        { name: "linked_campaign", label: "Campaign", required: true },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddDirectMailPopup;
